import { render, staticRenderFns } from "./DashboardIndustryStats.vue?vue&type=template&id=3b36ea1f&"
import script from "./DashboardIndustryStats.vue?vue&type=script&lang=js&"
export * from "./DashboardIndustryStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports